<div class="circular-progress-container" [style.width.px]="size" [style.height.px]="size">
  <svg 
    class="circular-progress-ring" 
    [attr.width]="size" 
    [attr.height]="size"
    [class.hover-enabled]="enableHover"
    [class.scale-enabled]="enableScale"
  >
    <circle
      *ngIf="showBackground"
      class="circular-progress-ring__background"
      [attr.cx]="size / 2"
      [attr.cy]="size / 2"
      [attr.r]="radius"
      [attr.stroke-width]="strokeWidth"
    />
    <circle
      class="circular-progress-ring__progress"
      [attr.cx]="size / 2"
      [attr.cy]="size / 2"
      [attr.r]="radius"
      [attr.stroke-width]="strokeWidth"
      [attr.stroke-dasharray]="strokeDasharray"
      [attr.stroke-dashoffset]="strokeDashoffset"
      [style.stroke]="getProgressColor()"
      [ngStyle]="getAnimationStyles()"
    />
  </svg>
  
  <img
    *ngIf="showImage && !shouldShowDefaultImage()"
    class="circular-progress-image"
    [src]="getImageSrc()"
    [alt]="imageAlt"
    [style.width.px]="size * 0.83"
    [style.height.px]="size * 0.83"
  />
  
  <div
    *ngIf="showImage && shouldShowDefaultImage()"
    class="circular-progress-default-image"
    [style.width.px]="size * 0.83"
    [style.height.px]="size * 0.83"
    [ngStyle]="getDefaultImageStyles()"
  >
    {{ getDefaultImageInitials() }}
  </div>
  
  <div 
    *ngIf="showPercentage"
    class="circular-progress-overlay"
    [class.clickable]="clickable"
    [class.bounce-enabled]="enableBounce"
    (click)="onProgressClick()"
  >
    <span 
      class="circular-progress-text"
      [style.color]="getProgressColor()"
      [class.pulse-enabled]="enablePulse"
    >
      {{ progress }}%
    </span>
  </div>
</div>
